import React from 'react';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';

const MOCPreviewContent = ({ mocData, printRef }) => {
  if (!mocData) return null;

  const {
    mocNo,
    mocDate,
    orderNumber,
    typeOfMOC,
    documentType,
    aluminiumWeight,
    poNumber,
    poDate,
    warehouse,
    customerName,
    totalMeterNumber,
    shippingAddress,
    materialCode,
    productSummary,
    components,
    totalWeight,
    materialChecklist,
    preparedBy,
    quantityVerifiedBy,
    quantityVerifiedByDispatch,
    vehicleNumber,
    vehicleInTime,
    vehicleOutTime,
    vehicleDate,
    paymentTerms,
    paymentStatus,
    lastPaymentAmount,
    outstandingAmount,
    paymentRecDate,
    outstandingDays,
    approvedByFinance,
    approvedBySalesperson,
  } = mocData;

  const headerTableCellStyle = { border: '1px solid #000', padding: '8px', fontSize: '13px' };
  const labelCellStyle = { ...headerTableCellStyle, fontWeight: 'bold', backgroundColor: '#f2f2f2' };
  const valueCellStyle = { ...headerTableCellStyle, backgroundColor: '#fff' };
  const headerTableStyle = { width: '100%', borderCollapse: 'collapse', marginBottom: '15px', border: '1px solid #000' };
  const pdfTableStyle = { width: '100%', borderCollapse: 'collapse', marginTop: '15px', border: '1px solid #000' };
  const pdfThStyle = { border: '1px solid #000', padding: '6px', fontSize: '12px', textAlign: 'center', fontWeight: 'bold' };
  const pdfTdStyle = { border: '1px solid #000', padding: '6px', fontSize: '12px', textAlign: 'center' };

  return (
    <div ref={printRef} style={{ padding: '20px', backgroundColor: 'white' }}>
      <table style={headerTableStyle}>
        <tbody>
          <tr><td colSpan="5" style={{ ...headerTableCellStyle, textAlign: 'center', backgroundColor: '#f1f5f9', fontWeight: '800', fontSize: '18px' }}>PACKAGING/BILL OF MATERIAL</td></tr>
          <tr>
            <td style={labelCellStyle}>Document date</td><td style={valueCellStyle}>{mocDate}</td>
            <td style={labelCellStyle}>Document No.</td><td style={valueCellStyle}>{mocNo}</td>
            <td style={valueCellStyle}><strong>Order No:</strong> {orderNumber || '---'}</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>Type of MOC</td><td style={valueCellStyle}>{typeOfMOC}</td>
            <td style={labelCellStyle}>Document type</td><td style={valueCellStyle}>{documentType}</td>
            <td style={{...valueCellStyle, backgroundColor: '#fdf2f2'}}><strong>ALW:</strong> {aluminiumWeight} kg</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>PO Number</td><td style={valueCellStyle}>{poNumber}</td>
            <td style={labelCellStyle}>PO DATE</td><td style={valueCellStyle}>{poDate}</td>
            <td style={valueCellStyle}><strong>Warehouse:</strong> {warehouse}</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>Consignee</td><td colSpan="3" style={{...valueCellStyle, fontWeight: 'bold'}}>{customerName}</td>
            <td rowSpan="4" style={{ ...headerTableCellStyle, textAlign: 'center', verticalAlign: 'middle', width: '120px' }}>
              <strong>Total Meter</strong><br /><span style={{ fontSize: '30px', fontWeight: '900' }}>{totalMeterNumber}</span>
            </td>
          </tr>
          <tr><td style={labelCellStyle}>Shipping Address</td><td colSpan="3" style={{ ...valueCellStyle, height: '60px', verticalAlign: 'top' }}>{shippingAddress}</td></tr>
          <tr><td style={labelCellStyle}>Material Code</td><td colSpan="3" style={valueCellStyle}>{materialCode}</td></tr>
          <tr><td style={labelCellStyle}>Product Summary</td><td colSpan="3" style={valueCellStyle}>{productSummary}</td></tr>
        </tbody>
      </table>

      {/* Component Table */}
      <table style={pdfTableStyle}>
        <thead>
          <tr style={{ backgroundColor: '#f8fafc' }}>
            <th style={pdfThStyle}>S.No</th><th style={pdfThStyle}>SKU</th><th style={{ ...pdfThStyle, textAlign: 'left' }}>Item Name</th><th style={pdfThStyle}>Order Qty</th><th style={pdfThStyle}>New Qty</th><th style={pdfThStyle}>Rental Qty</th><th style={pdfThStyle}>Total Weight</th>
          </tr>
        </thead>
        <tbody>
          {components?.map((c, i) => (
            <tr key={i}>
              <td style={pdfTdStyle}>{i + 1}</td><td style={pdfTdStyle}>{c.sku}</td><td style={{ ...pdfTdStyle, textAlign: 'left' }}>{c.name}</td><td style={pdfTdStyle}>{c.orderQty || 0}</td><td style={pdfTdStyle}>{c.newQty || 0}</td><td style={pdfTdStyle}>{c.rentalQty || 0}</td><td style={pdfTdStyle}>{((parseInt(c.newQty || 0) + parseInt(c.rentalQty || 0)) * parseFloat(c.weight || 0)).toFixed(2)} kg</td>
            </tr>
          ))}
          <tr style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
            <td colSpan="6" style={{ ...pdfTdStyle, textAlign: 'right' }}>TOTAL WEIGHT</td><td style={pdfTdStyle}>{parseFloat(totalWeight || 0).toFixed(2)} kg</td>
          </tr>
        </tbody>
      </table>

      {/* Material Checklist */}
      <table style={headerTableStyle}>
        <tbody>
          <tr><td style={labelCellStyle}>Stickers</td><td style={valueCellStyle}>{materialChecklist?.stickers ? 'YES' : 'NO'}</td><td style={labelCellStyle}>Laser Marking</td><td style={valueCellStyle}>{materialChecklist?.laserMarking ? 'YES' : 'NO'}</td><td style={labelCellStyle}>Material Wrapping</td><td style={valueCellStyle}>{materialChecklist?.materialWrapping ? 'YES' : 'NO'}</td></tr>
          <tr><td style={labelCellStyle}>Instructions</td><td colSpan="5" style={{ ...valueCellStyle, minHeight: '50px' }}>{materialChecklist?.materialInstructions || 'None'}</td></tr>
        </tbody>
      </table>

      {/* Verification Section */}
      <table style={headerTableStyle}>
        <tbody>
          <tr>
            <td style={labelCellStyle}>Prepared by</td><td style={valueCellStyle}>{preparedBy}</td>
            <td rowSpan="6" style={{ ...headerTableCellStyle, verticalAlign: 'top', fontSize: '11px', width: '45%', borderLeft: '2px solid #000' }}>
              <div style={{fontWeight: 'bold', marginBottom: '5px', textDecoration: 'underline'}}>NOTICE FOR SALES TEAM:</div>
              Sales Team, please verify the Material Quantity Against your BOM Before Signing the MOC. Any Discrepancies in the MOC Will Not Be the Responsibility of the Operations Team, As It Has Been Prepared Exactly As Per Your BOM.
            </td>
          </tr>
          <tr><td style={labelCellStyle}>Qty Verified By (Approval)</td><td style={valueCellStyle}>{quantityVerifiedBy}</td></tr>
          <tr><td style={labelCellStyle}>Qty Verified By (Dispatch)</td><td style={valueCellStyle}>{quantityVerifiedByDispatch}</td></tr>
          <tr><td style={labelCellStyle}>Vehicle Number</td><td style={valueCellStyle}>{vehicleNumber}</td></tr>
          <tr><td style={labelCellStyle}>Vehicle In Time</td><td style={valueCellStyle}>{vehicleInTime}</td></tr>
          <tr><td style={labelCellStyle}>Vehicle Out Time</td><td style={valueCellStyle}>{vehicleOutTime}</td></tr>
          <tr><td style={labelCellStyle}>Date</td><td style={valueCellStyle}>{vehicleDate}</td><td style={{ ...headerTableCellStyle, textAlign: 'center', fontWeight: 'bold', fontSize: '14px', backgroundColor: '#f2f2f2' }}>SIGNATURE</td></tr>
        </tbody>
      </table>

      {/* Finance Section */}
      <table style={headerTableStyle}>
        <tbody>
          <tr><td colSpan="4" style={{ ...headerTableCellStyle, textAlign: 'center', backgroundColor: '#f1f5f9', fontWeight: '800' }}>FOR FINANCE USE ONLY</td></tr>
          <tr><td style={{ ...labelCellStyle, width: '25%' }}>Payment Terms</td><td style={{ ...valueCellStyle, width: '25%' }}>{paymentTerms}</td><td style={{ ...labelCellStyle, width: '25%' }}>Payment Status</td><td style={{ ...valueCellStyle, width: '25%' }}>{paymentStatus}</td></tr>
          <tr><td style={labelCellStyle}>Last Payment amount</td><td style={valueCellStyle}>{lastPaymentAmount}</td><td style={labelCellStyle}>Outstanding Amount</td><td style={valueCellStyle}>{outstandingAmount}</td></tr>
          <tr><td style={labelCellStyle}>Payment Rec. Date</td><td style={valueCellStyle}>{paymentRecDate}</td><td style={labelCellStyle}>Outstanding days</td><td style={valueCellStyle}>{outstandingDays}</td></tr>
          <tr><td style={labelCellStyle}>Sign/Name (Finance)</td><td style={valueCellStyle}>{approvedByFinance}</td><td style={labelCellStyle}>Salesperson sign/name</td><td style={valueCellStyle}>{approvedBySalesperson}</td></tr>
        </tbody>
      </table>
    </div>
  );
};

export default MOCPreviewContent;
